export default {
  root: {
    backgroundColor: '#DBDBDB'
  }
}
